import {
  Stack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Text,
  Button,
  HStack,
} from "@chakra-ui/react";
import { logout } from "helpers/utils";
import { MdLogout } from "react-icons/md";

export default function NotFound() {
  return (
    <Stack
      height={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={8}
    >
      <Stack spacing={6}>
        <Text fontSize="4xl" fontWeight={"bold"} textAlign={"center"}>
          {process.env.REACT_APP_NAME}
        </Text>
        <Alert status="warning" variant="left-accent" alignItems={"start"}>
          <AlertIcon />
          <Stack>
            <AlertTitle>404 - Page not found</AlertTitle>
            <AlertDescription>
              We can't find the page you're looking for.
            </AlertDescription>
          </Stack>
        </Alert>
        <HStack width="100%">
          <Button flex={1} onClick={() => (window.location.href = "/")}>
            Go Home
          </Button>
          <Button
            onClick={logout}
            colorScheme="red"
            flex={1}
            rightIcon={<MdLogout />}
          >
            Logout
          </Button>
        </HStack>
      </Stack>
    </Stack>
  );
}
